/**
 * nav-v2.js — mega menu disclosure for sections/header-v2.liquid
 *
 * This is the only bespoke JS the navigation needs. The mobile drawer,
 * its accordion, predictive search and the cart drawer are all handled by
 * theme.js via the data attributes rendered in the Liquid.
 *
 * Pattern is a disclosure (button + aria-expanded + aria-controls), not a
 * menubar, so no arrow-key semantics are implied. Every link inside the panel
 * is a real anchor, so the menu degrades to a plain list if this never runs.
 */
(function () {
  'use strict';

  var BREAKPOINT = 990;
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 180;

  function NavV2(nav) {
    this.nav = nav;
    this.trigger = nav.querySelector('[data-nav-v2-trigger]');
    this.mega = nav.querySelector('[data-nav-v2-mega]');
    this.openTimer = null;
    this.closeTimer = null;

    if (!this.trigger || !this.mega) return;

    this.bind();
  }

  NavV2.prototype.setOpen = function (open) {
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);

    this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.mega.setAttribute('aria-hidden', open ? 'false' : 'true');
    this.mega.classList.toggle('is-open', open);
  };

  NavV2.prototype.isOpen = function () {
    return this.trigger.getAttribute('aria-expanded') === 'true';
  };

  NavV2.prototype.bind = function () {
    var self = this;

    this.onTriggerClick = function () {
      self.setOpen(!self.isOpen());
    };

    this.onTriggerEnter = function () {
      window.clearTimeout(self.closeTimer);
      self.openTimer = window.setTimeout(function () {
        self.setOpen(true);
      }, OPEN_DELAY);
    };

    this.onTriggerLeave = function () {
      window.clearTimeout(self.openTimer);
      self.closeTimer = window.setTimeout(function () {
        self.setOpen(false);
      }, CLOSE_DELAY);
    };

    this.onMegaEnter = function () {
      window.clearTimeout(self.closeTimer);
    };

    this.onMegaLeave = function () {
      self.closeTimer = window.setTimeout(function () {
        self.setOpen(false);
      }, CLOSE_DELAY);
    };

    this.onKeydown = function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      if (!self.isOpen()) return;

      self.setOpen(false);
      self.trigger.focus();
    };

    this.onDocumentClick = function (event) {
      if (!self.isOpen()) return;
      if (self.nav.contains(event.target)) return;

      self.setOpen(false);
    };

    this.onFocusIn = function (event) {
      if (!self.isOpen()) return;
      if (self.nav.contains(event.target)) return;

      self.setOpen(false);
    };

    this.onResize = function () {
      if (window.innerWidth < BREAKPOINT && self.isOpen()) {
        self.setOpen(false);
      }
    };

    this.trigger.addEventListener('click', this.onTriggerClick);
    this.trigger.addEventListener('mouseenter', this.onTriggerEnter);
    this.trigger.addEventListener('mouseleave', this.onTriggerLeave);
    this.mega.addEventListener('mouseenter', this.onMegaEnter);
    this.mega.addEventListener('mouseleave', this.onMegaLeave);
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('focusin', this.onFocusIn);
    window.addEventListener('resize', this.onResize);
  };

  NavV2.prototype.destroy = function () {
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);

    if (!this.trigger || !this.mega) return;

    this.trigger.removeEventListener('click', this.onTriggerClick);
    this.trigger.removeEventListener('mouseenter', this.onTriggerEnter);
    this.trigger.removeEventListener('mouseleave', this.onTriggerLeave);
    this.mega.removeEventListener('mouseenter', this.onMegaEnter);
    this.mega.removeEventListener('mouseleave', this.onMegaLeave);
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('focusin', this.onFocusIn);
    window.removeEventListener('resize', this.onResize);
  };

  var instances = [];

  function init() {
    destroy();

    var navs = document.querySelectorAll('.nav-v2');
    for (var i = 0; i < navs.length; i++) {
      instances.push(new NavV2(navs[i]));
    }
  }

  function destroy() {
    for (var i = 0; i < instances.length; i++) {
      instances[i].destroy();
    }
    instances = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section on every settings change.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.nav-v2')) init();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('.nav-v2')) destroy();
  });
})();
